<div class="container mt-3 fade-in-left">
    <div class="d-flex align-items-center justify-content-center mb-5 me-4">
        <div class="p-2"><a [routerLink]="['/sign-in']"><i class="bi bi-chevron-left align-middle"></i></a></div>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center">Información importante</h1></div>
    </div>

    <div class="row-cols-12 m-4 mt-0">
        <div class="row p-3 mt-5 mb-5 error-positioning">
            <i class="bi bi-info-circle mt-5 text-center" style="font-size: 2em;"></i>
            <div class="description mb-5 mt-2 text-center">Ha ocurrido un error</div>
        </div>
        <div class="d-grid mt-5 mb-2"><button type="button" [routerLink]="['/sign-in']" class="btn btn-primary btn-lg mt-5">Volver</button></div>
    </div>
</div>